import i18n, { Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEn from './en/translation.json';
import translationEs from './es/translation.json';
import translationPt from './pt-BR/translation.json';
import { isProduction } from '../constants';

export enum LANGUAGE_ENUM {
  'pt-BR' = 'pt-BR',
  'en' = 'en',
  'es' = 'es'
}

export const resources: Resource = {
  [LANGUAGE_ENUM.en]: {
    translation: translationEn
  },
  [LANGUAGE_ENUM.es]: {
    translation: translationEs
  },
  [LANGUAGE_ENUM['pt-BR']]: {
    translation: translationPt
  }
} as const;

const lang: keyof typeof LANGUAGE_ENUM = LANGUAGE_ENUM.es; // only for local test

const defaultLanguage = isProduction
  ? {
      fallbackLng: LANGUAGE_ENUM.es
    }
  : {
      lng: lang,
      fallbackLng: lang
    };

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    ...defaultLanguage,
    debug: !isProduction,
    interpolation: {
      escapeValue: false // not needed for react as it escapes by default
    },
    resources
  });

export default i18n;
